function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import flatten from 'lodash.flatten';
class DragUtils {
  /**
   * Re-orders the provided item lists in place based on the selectedRanges and destinationIndex provided
   * @param sourceList Array of the source items
   * @param selectedRanges Array of the selected ranges in the source list
   * @param destinationList Destination items. If dragging within the same list, set it to sourceItems
   * @param destinationIndex The index items are being dropped in the destinationList, adjusted for the removed items
   * @returns The items that were dragged
   */
  static reorder(sourceList, selectedRanges, destinationList, destinationIndex) {
    var insertIndex = sourceList === destinationList ? DragUtils.adjustDestinationIndex(destinationIndex, selectedRanges) : destinationIndex;
    var draggedItems = DragUtils.removeItems(sourceList, selectedRanges);
    destinationList.splice(insertIndex, 0, ...draggedItems);
    return draggedItems;
  }

  /**
   * Removes the provided ranges from the list in place
   * @param list Array of items to remove the ranges.
   * @param ranges Array of the ranges to remove.
   * @returns The removed items, in the order of the ranges removed.
   */
  static removeItems(list, ranges) {
    var items = [];

    // Sort them in reverse, so we don't screw up the range indexes
    var sortedRanges = ranges.map((range, index) => ({
      range,
      index
    })).sort((a, b) => b.range[0] - a.range[0]);
    for (var i = 0; i < sortedRanges.length; i += 1) {
      var _sortedRanges$i = sortedRanges[i],
        range = _sortedRanges$i.range,
        index = _sortedRanges$i.index;
      var _range = _slicedToArray(range, 2),
        start = _range[0],
        end = _range[1];
      items[index] = list.splice(start, end - start + 1);
    }
    return flatten(items);
  }

  /**
   * Adjusts the destination index for when dropping into the same list you're dragging from.
   * @param destinationIndex The original destination index
   * @param ranges The ranges that are moving
   * @returns Index where item should be inserted after all ranges are removed
   */
  static adjustDestinationIndex(destinationIndex, ranges) {
    var adjustedIndex = destinationIndex;
    for (var i = 0; i < ranges.length; i += 1) {
      var _ranges$i = _slicedToArray(ranges[i], 2),
        start = _ranges$i[0],
        end = _ranges$i[1];
      if (start > destinationIndex) {
        break;
      }
      adjustedIndex -= Math.min(end, destinationIndex - 1) - start + 1;
    }
    return adjustedIndex;
  }
  static startDragging() {
    document.documentElement.classList.add('drag-pointer-events-none');
  }
  static stopDragging() {
    document.documentElement.classList.remove('drag-pointer-events-none');
  }
}
export default DragUtils;
//# sourceMappingURL=DragUtils.js.map